import { ApiError } from "@/client"

const isEmbedAppRoute = (path: string) => path === "/embed/app"

export const shouldRedirectToLogin = (
  error: unknown,
  currentPath?: string,
): boolean => {
  const path =
    currentPath ??
    (typeof window !== "undefined" ? window.location.pathname : "")

  if (!(error instanceof ApiError)) {
    return false
  }

  if (![401, 403].includes(error.status)) {
    return false
  }

  // A 403 is often a real authorization failure (insufficient permissions),
  // not an authentication failure. Only redirect to login for 403s that
  // indicate an invalid/expired token.
  if (error.status === 403) {
    const detail = (error.body as any)?.detail
    if (detail !== "Could not validate credentials") {
      return false
    }
  }

  return !isEmbedAppRoute(path)
}
